import { cn } from "../../lib/utils";

/** Compact orb mascot for Morrow sub-agent cards and working indicators. */
export function MorrowAgentOrb({ className }: { readonly className?: string }) {
  return (
    <img
      alt=""
      aria-hidden="true"
      className={cn("shrink-0 object-contain", className)}
      src="/brand/morrow-mascot-orb.png"
    />
  );
}
